import AuthController from "api/controllers/AuthController";
import UserController from "api/controllers/UserController";
import { AuthException } from "api/exceptions/AuthException";
import AuthService from "api/services/AuthService";
import { makeAutoObservable } from "mobx";
import { lang } from "../i18nLang";
import { MessageStore, UserStore } from "./";

export const enum TabsProfile {
  MY_PROFILE = 0,
  COMPANY = 1,
  USERS = 2,
  ACCESS_PROFILE = 3,
}

class Store {
  private _enableLayerProfile: boolean = false;
  private _currentTab: TabsProfile = 0;

  constructor() {
    makeAutoObservable(this);
  }

  reset() {
    this._enableLayerProfile = false;
    this._currentTab = 0;
  }

  get enableLayerProfile(): boolean {
    return this._enableLayerProfile;
  }

  get currentTab(): number {
    return this._currentTab;
  }

  setCurrentTab(value: number) {
    this._currentTab = value;
  }

  openProfileLayer(tab: TabsProfile = 0) {
    this._enableLayerProfile = true;
    this._currentTab = tab;
  }

  closeProfileLayer() {
    this._enableLayerProfile = false;
  }

  async updateProfile({ name, email }, photo?: File) {
    const user = UserStore.currentUser;
    if (!user) return;

    return UserController.updateProfile(user, name, photo)
      .then(() => UserController.updateUserEmail(user, email))
      .then(() => {
        if (photo) UserStore.setUserPhoto(photo);
        MessageStore.success("O perfil do usuário foi editado com sucesso.");
      })
      .catch((error) => {
        if (error instanceof AuthException) {
          MessageStore.error(error.message);
        } else {
          MessageStore.error(
            "Erro ao editar perfil, tente novamente mais tarde."
          );
        }
        throw error;
      });
  }

  async resetPassword() {
    const user = UserStore.currentUser;
    if (!user) return;

    return AuthController.sendPasswordResetEmail(user.email)
      .then(() => {
        MessageStore.info(lang("login.resetPassword.emailSent"));
      })
      .catch((error) => {
        console.error(error);
        MessageStore.error(lang("login.resetPassword.emailErrorSent"));
      });
  }

  async sendVerificationEmail() {
    return AuthService.sendVerificationEmail()
      .then(() => {
        MessageStore.success("E-mail de verificação enviado!");
      })
      .catch((error) => {
        console.error(error);
        MessageStore.error("Erro ao enviar e-mail, tente novamente mais tarde");
      });
  }
}

const ProfileStore = new Store();
export default ProfileStore;
